/** @jsxImportSource @emotion/react */
import React from 'react';
import { Menu } from '../menu/menu.component';
import { LangList } from '../lang-list/lang-list.component';
import { SupportMenu } from '../support-menu/support-menu.component';
import { IStation } from '../../api/station/types';
import { Z_INDEX } from '../../constants/zIndex';
import { menuBlockStyles } from './menu-block.styles';
import CollapsedCharge from '../collapsed-charge/collapsed-charge';

type TProps = {
    style?: React.CSSProperties;
    station?: IStation;
};

function MenuBlock({ style, station }: TProps) {
    if (station) {
        return (
            <div css={menuBlockStyles.blockWithStation}>
                <div css={menuBlockStyles.stationInfo}>
                    {station?.chargePointSerialNumber ?? station?.identity}
                </div>
                <div css={menuBlockStyles.menuBlockWithStation}>
                    <LangList zIndex={Z_INDEX.DRAWER_LANG} />
                    <SupportMenu />
                    <Menu zIndex={Z_INDEX.DRAWER_MENU} />
                </div>
            </div>
        );
    }

    return (
        <div css={menuBlockStyles.block} style={style}>
            <CollapsedCharge />
            <LangList />
            <Menu />
        </div>
    );
}

export default MenuBlock;
